import styled from 'styled-components';

export interface FlexProps {
  display?: string;
  justifyContent?: React.CSSProperties['justifyContent'];
  flexDirection?: React.CSSProperties['flexDirection'];
  flexGrow?: React.CSSProperties['flexGrow'];
  flexBasis?: React.CSSProperties['flexBasis'];
  flexShrink?: React.CSSProperties['flexShrink'];
  flexWrap?: React.CSSProperties['flexWrap'];
  flex?: React.CSSProperties['flex'];
  alignItems?: React.CSSProperties['alignItems'];
  margin?: React.CSSProperties['margin'];
  padding?: React.CSSProperties['padding'];
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
  maxWidth?: React.CSSProperties['maxWidth'];
  minHeight?: React.CSSProperties['minHeight'];
  minWidth?: React.CSSProperties['minWidth'];
  overflow?: React.CSSProperties['overflow'];
  overflowX?: React.CSSProperties['overflowX'];
  overflowY?: React.CSSProperties['overflowY'];
  gap?: React.CSSProperties['gap'];
  verticalGap?: string | number;
  zIndex?: React.CSSProperties['zIndex'];
}

export const Flex = styled.div<FlexProps>(
  ({
    display,
    justifyContent = 'flex-start',
    flexDirection = 'column',
    flexGrow = 0,
    flexBasis = 'auto',
    flexShrink = 1,
    flexWrap = 'nowrap',
    flex = '0 1 auto',
    alignItems = 'flex-start',
    margin = '0',
    padding = '0',
    width = 'auto',
    height = 'auto',
    minHeight = 'unset',
    minWidth = 'unset',
    maxWidth = 'none',
    overflow,
    overflowX,
    overflowY,
    gap = 0,
    verticalGap = 0,
    zIndex,
  }) => ({
    display: display || 'flex',
    justifyContent,
    flexDirection,
    flexGrow,
    flexBasis,
    flexShrink,
    flexWrap,
    flex,
    alignItems,
    margin,
    padding,
    width,
    height,
    minHeight,
    minWidth,
    maxWidth,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ...(gap && {
      '> *:not(:last-child)': {
        marginRight: gap,
      },
    }),
    ...(verticalGap && {
      '> *:not(:last-child)': {
        marginBottom: verticalGap,
      },
    }),
    ...(gap &&
      verticalGap && {
        '> *:not(:last-child)': {
          marginRight: gap,
          marginBottom: verticalGap,
        },
      }),
  }),
);
